import { createSelector } from '@ngrx/store';

export const getPaymentPurposesState = createSelector(
    (state: any) => state.paymentPurposes,
    (state: any) => state.get('list')
);

export const getCreatePaymentPurposeState = createSelector(
    (state: any) => state.paymentPurposes,
    (state: any) => state.get('createPaymentPurpose')
);

export const getUpdatePaymentPurposeState = createSelector(
    (state: any) => state.paymentPurposes,
    (state: any) => state.get('updatePaymentPurpose')
);
 